import React, { useEffect } from 'react'
import { ProjectsPageProps } from './ProjectsPage.types'
import styles from './ProjectsPage.module.scss'
import cl from 'classnames'
import { PageHeader, ProjectsTable } from 'components/shared'
import { inject } from 'mobx-react'
import { PROJECTS_TABLE_STORE, PROJECT_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { IconProjects } from 'assets'

const ProjectsPageComponent = (props: ProjectsPageProps) => {
  const {
    [PROJECT_STORE]: {
      getProjects
    },
    [PROJECTS_TABLE_STORE]: {
      setSearchResults,
      triggerSearch
    },
    history: { push }
  } = props

  useEffect(() => {
    getProjects(true)
      .then(projects => {
        setSearchResults(projects)
        triggerSearch()
      })
  }, [getProjects, setSearchResults, triggerSearch])

  return (
    <div className={cl(styles.container, styles.scrollable)} style={{ overflow: 'hidden' }}>

      <PageHeader
        // className={styles.pageHeader}
        navSegments={[{
          label: 'Projects',
          icon: IconProjects
        }]}
        buttons={[{
          preset: 'primary',
          children: 'Add a new project',
          onClick: () => {
            localStorage.removeItem("manageVideoStatus");
            localStorage.removeItem("readyForEdit");
            push('/projects/create');
          }
        }]}
      />

      <ProjectsTable
        style={{overflowX: 'auto' }}
      />
    </div>
  )
}

const ProjectsPage = inject(
  PROJECT_STORE, PROJECTS_TABLE_STORE
)(observer(ProjectsPageComponent))
export { ProjectsPage }
